import Button from '@carvana/ds-button';
import cx from 'classnames';
import { useContext, useMemo } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import getOutOfAreaVariant from './getOutOfAreaVariant';

type OwnProps = {
  showDesktopActions?: boolean;
};

export default function OutOfAreaErrorContent({
  showDesktopActions = false
}: OwnProps) {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const { notAvailableInCA, outOfMarket, outOfMarketNewCar } = useAlertStatus();

  const variant = useMemo(
    () =>
      getOutOfAreaVariant({
        notAvailableInCA,
        outOfMarket,
        outOfMarketNewCar
      }),
    [notAvailableInCA, outOfMarket, outOfMarketNewCar]
  );

  return variant ? (
    <div
      role="alert"
      className={cx(
        'flex flex-col items-start gap-xl self-stretch bg-background-weak -mx-2xl -mb-2xl -mt-lg px-2xl pb-2xl pt-xl lg:-mx-4xl lg:-mb-4xl lg:-mt-0 lg:gap-none lg:px-4xl lg:pb-4xl lg:pt-3xl',
        showDesktopActions ? 'sm:rounded-b-none' : 'sm:rounded-b-xl'
      )}
    >
      <h3 className="self-stretch text-text-strong t-heading-sm lg:flex-1 lg:t-heading-md">
        {variant.heading}
      </h3>
      <p className="self-stretch text-text-strong t-body-sm">
        {variant.description}
      </p>
      <Button
        data-adobe-id="out-of-area-change-location"
        data-analytics-id={variant.analyticsId}
        data-testid={variant.testId}
        onClick={() => setGeolocationModalOpen(true)}
        variant="secondary"
        size="md"
        width="auto"
        className="w-full self-stretch lg:h-[56px] lg:py-[14px]"
      >
        Change Location
      </Button>
    </div>
  ) : null;
}
